import Banner from "../components/Banner.tsx";
import { Outlet, useParams } from "react-router-dom";

import { useGame } from "../utils/GameContexte.tsx";
import { useNavigate } from "react-router-dom";
import Container from "./Container.tsx";
import { useEffect, useRef } from "react";

import gsap from "gsap";

function JeuLayout() {
  const { id } = useParams();
  const navigate = useNavigate();
  const bannerRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  let localEquipesIcon = "";

  const title =
    id === "entrainement"
      ? "Entraînement"
      : id === "expert"
      ? "Mode expert"
      : "Mode classique";

  const {
    questionNumber,
    totalPoints,
    totalQuestions,
    totalPlayers,
    equipesIcons,
    activePlayer,
    equipesPoints,
    equipesNoms,
  } = useGame();

  useEffect(() => {
    if (
      (id === "entrainement" && totalQuestions === 0) ||
      (id === "entrainement" && totalQuestions === 1)
    ) {
      navigate("/accueil");
    }
  }, [totalQuestions, navigate, id]);

  useEffect(() => {
    if (containerRef.current) {
      gsap.set(containerRef.current, {
        height: 0, // Commencez avec une hauteur de 0
        overflow: "hidden", // Gardez le contenu caché pendant l'animation
      });

      const tl = gsap.timeline();

      tl.to(containerRef.current, {
        height: "100%", // Animer la hauteur jusqu'à 100%
        duration: 1,
        ease: "power3.inOut", // Une accélération douce pour l'animation
      });
    }
  }, []);

  // Préparer le texte du compteur de questions pour le mode entraînement
  const questionCounterText =
    id === "entrainement"
      ? `${questionNumber} / ${totalQuestions !== 0 ? totalQuestions : "0"}`
      : `${questionNumber}`;

  let equipesList: JSX.Element[] = []; // Initialisation de equipesList comme un tableau vide

  if (totalPlayers > 1) {
    const equipesCount = 5;
    for (let i = 0; i < equipesCount - equipesIcons.length; i++) {
      equipesIcons.push("");
    }

    equipesList = equipesNoms.map((equipeIcon, index) => {
      localEquipesIcon =
        id === "expert" && equipeIcon !== ""
          ? "./equipes/red/" + equipeIcon + ".svg"
          : "./equipes/blue/" + equipeIcon + ".svg";
      return (
        <li
          className={`jeuLayout__listItem ${
            activePlayer === index ? "active" : "inactive"
          }`}
          key={`${equipeIcon}--${index}`}
        >
          <figure className="jeuLayout__icon jeuLayout__icon--size" key={index}>
            <img src={localEquipesIcon} alt={`Equipe ${equipeIcon}`} />
          </figure>
          <p>{`${equipesPoints[index]} pt${
            equipesPoints[index] <= 0 ? "" : "s"
          }`}</p>
        </li>
      );
    });

    if (equipesList.length < 5) {
      const neededEmptyIcons = 5 - equipesList.length;
      for (let i = 0; i < neededEmptyIcons; i++) {
        equipesList.push(
          <li className="jeuLayout__listItem" key={`empty--${i}`}>
            <div
              className={`jeuLayout__icon jeuLayout__icon--size empty empty--${
                id === "expert" ? "red" : "blue"
              }`}
              key={i}
            ></div>
            <p>-</p>
          </li>
        );
      }
    }
  }
  return (
    <>
      <Banner
        color={`${id === "expert" ? "red" : "blue"}`}
        bannerRef={bannerRef}
      >
        <div className="banner--jeu">
          <p className="jeuBanner__title">{title}</p>

          <div className="jeuBanner jeuBanner__content">
            {totalPlayers === 1 && (
              <>
                <p>
                  Question
                  <span>{questionCounterText}</span>
                </p>
                <p>{`${totalPoints} pt${totalPoints > 1 ? "s" : ""}`}</p>
              </>
            )}
            {totalPlayers > 1 && equipesList && (
              <ul className="jeuLayout__equipesList">{equipesList}</ul>
            )}
          </div>
        </div>
      </Banner>
      <Container ref={containerRef} color="white">
        <Outlet />
      </Container>
    </>
  );
}

export default JeuLayout;
